import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { map, catchError } from 'rxjs/operators';
import { Observable, of } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class OrquestadorService {

  private baseUrl!: string;

  constructor(private http: HttpClient) { }

  setBaseUrl(url: string) {
    this.baseUrl = url;
  }

  

  generalOrquestador(body: any, headers: HttpHeaders, errorHandler?: (error: any) => void): Observable<any> {

   

    return this.http.post<any>(this.baseUrl, body, { headers, observe: 'response' }).pipe(
      map(response => {
        if (response && response.body.data && response.body.error === false) {
         
          return response.body.data;
        } else if (response.body.error === true) {
       
          throw { error: true, message: response.body.data.message || response.body.data.Reason, status: response.status };  // Lanzar un objeto de error con mensaje
        } else {
         
          return response;
        }
      }),
      catchError(error=> {

        const errorMessage = error.message || error.Reason || 'Unknown';
        if (errorHandler) {
          errorHandler({ error: true, message: errorMessage, status: error.status });
        }
        return of({ error: true, message: errorMessage, status: error.status });
      })
    );
  }
}
